import { AutocompleteRenderGroupParams, Typography } from '@mui/material'
import React from 'react'

import { ProvenanceTargetType } from 'components/attacks/create/create-attack-types'
import {
  HOST_TARGETING_SECTION_DISPLAY_NAMES,
  KUBERNETES_TARGETING_SECTION_DISPLAY_NAMES
} from 'components/services/create/target-selection/service-target-utils'

export const TagTargetingAutocompleteGroupItem = React.forwardRef<
  HTMLLIElement,
  {
    params: AutocompleteRenderGroupParams
    type: ProvenanceTargetType
  }
>(({ params, type, ...rest }, ref) => {
  const isKubernetes = type === ProvenanceTargetType.Kubernetes
  const sectionDisplayNamesDictionary = isKubernetes
    ? KUBERNETES_TARGETING_SECTION_DISPLAY_NAMES
    : HOST_TARGETING_SECTION_DISPLAY_NAMES

  const sectionDisplayName =
    sectionDisplayNamesDictionary[params.group] || params.group

  return (
    <li {...rest} ref={ref}>
      <Typography
        color="primary"
        data-test-autocomplete-target-group-name={params.group}
        sx={{
          paddingBottom: 1,
          paddingLeft: 2,
          paddingTop: 2
        }}
      >
        {sectionDisplayName}
      </Typography>
      {!isKubernetes && (
        <Typography
          data-test-autocomplete-target-group-items
          component="ul"
          sx={{
            paddingLeft: 3
          }}
        >
          {params.children}
        </Typography>
      )}
    </li>
  )
})

TagTargetingAutocompleteGroupItem.displayName =
  'TagTargetingAutocompleteGroupItem'
